import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getStudentDetailById } from "../../../../../store/actions/student";
import { formatCurrency } from "../../../../../utils/currency";
import moment from "moment";
import "./mobilecard.css";

const MobileCard = ({ data, type }) => {
  const dispatch = useDispatch();
  const [studentPic, setStudentPic] = useState();

  useEffect(() => {
    if (!data?.studentId?._id) return;

    const fetchStudentPic = async () => {
      try {
        const student = await dispatch(getStudentDetailById(data.studentId._id));
        if (student?.[0]?.profilePic?.data) {
          setStudentPic(student[0].profilePic.data);
        }
      } catch (error) {
        console.error("Failed to fetch student pic:", error);
      }
    };

    fetchStudentPic();
  }, [data, dispatch]);

  // Calculate amounts for earnings
  const totalPaid = type === "Earnings" ? Number(data?.totalAfterDiscount || data?.total || data?.itemPrice || 0) : 0;
  const platformFee = type === "Earnings" ? Number(data?.platformFees || 0) : 0;
  const netEarning = totalPaid - platformFee;

  return (
    <div className="mobilecard">
      {type === "Earnings" && (
        <>
          <div className="personalInfo">
            <img
              src={data.studentId?.profilePic || studentPic || "https://ui-avatars.com/api/?name=" + (data.studentId?.fullName || "Student")}
              alt={data.studentId?.fullName || "Student"}
              style={{ height: "40px", width: "40px", borderRadius: "50%", objectFit: "cover" }}
            />
            <div className="name" style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
              {data.studentId?.fullName || "-"}
            </div>
          </div>

          <div className="courseInfo">
            <div className="infoItem">
              <span className="label">Course:</span>
              <span className="value">{data.courseId?.title?.data || data.courseId?.title || "-"}</span>
            </div>
            <div className="infoItem">
              <span className="label">Date:</span>
              <span className="value">{data.createdAt ? moment(data.createdAt).format("D-MM-YYYY h:mm a") : "-"}</span>
            </div>
            <div className="infoItem">
              <span className="label">Transaction ID:</span>
              <span className="value" style={{ fontSize: "0.8rem" }}>{data._id || "-"}</span>
            </div>
          </div>

          <div className="earningsBreakdown" style={{ borderTop: "1px solid #eee", paddingTop: "0.5rem", marginTop: "0.5rem" }}>
            <div className="infoItem" style={{ display: "flex", justifyContent: "space-between" }}>
              <span className="label">Paid Amount:</span>
              <span className="value">{formatCurrency(totalPaid)}</span>
            </div>
            <div className="infoItem" style={{ display: "flex", justifyContent: "space-between", color: "#d9534f" }}>
              <span className="label">Platform Fee:</span>
              <span className="value">- {formatCurrency(platformFee)}</span>
            </div>
            <div className="infoItem" style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#5cb85c", fontSize: "1.1rem" }}>
              <span className="label">Net Earning:</span>
              <span className="value">{formatCurrency(netEarning)}</span>
            </div>
          </div>
        </>
      )}

      {type === "Withdrawals" && (
        <div className="courseInfo">
          <div className="infoItem" style={{ display: "flex", justifyContent: "space-between" }}>
            <span className="label">Gross Amount:</span>
            <span className="value">{formatCurrency(data?.grossAmount || data?.withdrawalAmount || 0)}</span>
          </div>
          <div className="infoItem" style={{ display: "flex", justifyContent: "space-between", color: "#d9534f" }}>
            <span className="label">Platform Fee (21%):</span>
            <span className="value">- {formatCurrency(data?.platformFee || 0)}</span>
          </div>
          <div className="infoItem" style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", color: "#5cb85c", fontSize: "1.1rem" }}>
            <span className="label">Net Payout:</span>
            <span className="value">{formatCurrency(data?.amount || ((data?.grossAmount || data?.withdrawalAmount || 0) - (data?.platformFee || 0)))}</span>
          </div>

          <div className="infoItem" style={{ marginTop: "0.8rem", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <span className="label">Status:</span>
              <span className="value" style={{
                padding: "2px 6px",
                borderRadius: "8px",
                backgroundColor: data?.status === "Completed" ? "#dff0d8" : data?.status === "Failed" || data?.status === "Rejected" ? "#f2dede" : "#fcf8e3",
                color: data?.status === "Completed" ? "#3c763d" : data?.status === "Failed" || data?.status === "Rejected" ? "#a94442" : "#8a6d3b"
              }}>
                {data?.status || "Pending"}
              </span>
            </div>
            {data?.status === "Completed" && data?.transactionId && (
              <div style={{ fontSize: '0.75rem', color: '#666', width: '100%', textAlign: 'right' }}>UTR: {data.transactionId}</div>
            )}
            {data?.status === "Completed" && data?.completedAt && (
              <div style={{ fontSize: '0.7rem', color: '#888', width: '100%', textAlign: 'right' }}>
                Paid on: {moment(data.completedAt).format("D-MM-YY, h:mm a")}
              </div>
            )}
            {data?.status === "Failed" && data?.failureReason && (
              <div style={{ fontSize: '0.75rem', color: '#d9534f', width: '100%', textAlign: 'right' }}>Reason: {data.failureReason}</div>
            )}
          </div>

          <div className="infoItem">
            <span className="label">Date:</span>
            <span className="value">{data?.createdAt ? moment(data.createdAt).format("D-MM-YYYY h:mm a") : "-"}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileCard;
